
import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';
import { MessageModel } from '../maintenance.message/model/message.model';
import { ApiMessageDescriptor } from '../maintenance.message/model/api.message';
import { SignalRService } from '../../services/signalr.service';
import * as moment from 'moment';
import { Subscription } from 'rxjs';

@Injectable()
export class MaintenanceMessageFetchService extends RESTServiceBase {
  private _currentMessage: MessageModel = undefined;
  private _upcomingMessage: MessageModel = undefined;
  private maintenanceMessageSubscription: Subscription;

  constructor(
    private signalRService: SignalRService,
    private authService: AuthService,
    config: AppConfig
  ) {
    super(
      'v1',
      'MessageManagement',
      authService,
      config.MMMSConfig
    );

    signalRService.ConnectionEvents.subscribe(ce => {
      if (this.maintenanceMessageSubscription) {
        this.maintenanceMessageSubscription.unsubscribe();
        this.maintenanceMessageSubscription = undefined;
      }

      if (ce) {
        this.maintenanceMessageSubscription = signalRService.addPublishCurrentMaintenanceMessageListener().subscribe(mm => { 
          this._currentMessage = mm.activeMessage; 
          this._upcomingMessage = mm.upcomingMessage;
        });
      }
    }); 
  }

  public async getCurrentMessage(): Promise<MessageModel> {

    if (this.signalRService.IsConnected) return this._currentMessage;

    const filter = new View();

    filter.addOrUpdateFilter('Visible', 'true');
    filter.addOrderBy('VisibleFrom', 'A');
    filter.Limit = 1;

    const messages = await super.get<List<ApiMessageDescriptor>>(undefined, filter);
    messages.value = messages.value.map(o => new MessageModel(o));

    const messageList = messages as List<MessageModel>;
    this._currentMessage = (messageList.value.length > 0) ? messageList.value[0] : undefined;

    return this._currentMessage;
  }

  public async getUpcomingMessage(): Promise<MessageModel> {

    if (this.signalRService.IsConnected) return this._upcomingMessage;

    const offset = moment.duration(30, 'minutes');
    const base = moment().add(offset).toISOString();
    const now = moment().toISOString();
    
    const filter = new View();

    filter.addOrUpdateFilter('VisibleFrom', now + ';' + base);
    filter.addOrUpdateFilter('deleted', 'false');
    filter.addOrderBy('VisibleFrom', 'A');
    filter.Limit = 1;

    const messages = await super.get<List<ApiMessageDescriptor>>(undefined, filter);
    messages.value = messages.value.map(o => new MessageModel(o));

    const messageList = messages as List<MessageModel>;
    this._upcomingMessage = (messageList.value.length > 0) ? messageList.value[0] : undefined;

    return this._upcomingMessage;
  }
}




// WEBPACK FOOTER //
// ./src/app/modules/maintenance.message.modal/maintenance.message.service.ts